var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChillZone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 118,
    viewBox: "0 0 102 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1616 83.1836L33.4826 83.2774L8.79242 100.877L89.3975 96.3577L67.1616 83.1836Z",
    fill: "#FFB52E",
    stroke: "#0B0A0B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 89.5707H58.5L63 76.5576L44 73.7287V89.5707Z",
    fill: "#FFB52E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55 47.9013L44 46.5707V59.0182L67.5 61.2813L71 49.3997L58.5 48.268L55 47.9013Z",
    fill: "#FFB52E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34.6052L55 47.9013L58.5 48.268L59 37.4342H66V34.6052H56Z",
    fill: "#FFB52E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 61.2813L44 59.0182V73.7287L63 76.5576L67.5 61.2813Z",
    fill: "#FFB52E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55 47.9013L44 46.5707V59.0182M55 47.9013L56 34.6052H66V37.4342H59L58.5 48.268M55 47.9013L58.5 48.268M58.5 48.268L71 49.3997L67.5 61.2813M44 59.0182L67.5 61.2813M44 59.0182V73.7287M67.5 61.2813L63 76.5576M63 76.5576L58.5 89.5707H44V73.7287M63 76.5576L44 73.7287",
    stroke: "#0B0A0B",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChillZone);
export default __webpack_public_path__ + "static/media/chillZone.603074207f2e94931ef8098898431662.svg";
export { ForwardRef as ReactComponent };